export const parseStatus = {
  SUCCESS: 'success',
  FAILED: 'failed - see console for details',
};

export const UUID_REGEX = /[\da-f]{8}_[\da-f]{4}_4[\da-f]{3}_[\da-f]{4}_[\da-f]{12}/gim;
